import { render, staticRenderFns } from "./AnalysisSummary.vue?vue&type=template&id=72d7cdb8&scoped=true&"
import script from "./AnalysisSummary.vue?vue&type=script&lang=ts&"
export * from "./AnalysisSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AnalysisSummary.vue?vue&type=style&index=0&id=72d7cdb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7cdb8",
  null
  
)

export default component.exports